import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MassiveEditKirsActions } from './massive-edit-kirs.actions';
import { KirsAssessmentService } from '../../service/kirs-assessment.service';
import { KirsService } from '../../service/kirs.service';


@Injectable()
export class MassiveEditKirsEffects {

  loadKirsAssessment$ = createEffect(
    (cd: KirsAssessmentService = inject(KirsAssessmentService)) => {
      return this.actions$.pipe(

        ofType(MassiveEditKirsActions.loadKirsAssessments),
        mergeMap(({ campaignId, parameters, attestationId, legalEntityIds }) =>
          cd.getKirsAssessment(campaignId, attestationId, legalEntityIds, parameters).pipe(
            map((giasAssessments) => {
              return MassiveEditKirsActions.loadKirsAssessmentsSuccess({
                giasAssessments
              });
            }),
            catchError((error) => of(MassiveEditKirsActions.loadKirsAssessmentsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadAllGiasAssessment$ = createEffect(
    (cd: KirsAssessmentService = inject(KirsAssessmentService)) => {
      return this.actions$.pipe(

        ofType(MassiveEditKirsActions.loadAllKirsAssessments),
        mergeMap(({ campaignId, parameters, attestationId, legalEntityIds }) =>
          cd.getKirsAssessment(campaignId, attestationId, legalEntityIds, parameters).pipe(
            map((giasAssessments) => {
              return MassiveEditKirsActions.loadAllKirsAssessmentsSuccess({
                giasAssessments
              });
            }),
            catchError((error) => of(MassiveEditKirsActions.loadAllKirsAssessmentsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  createAndSignAssessment$ = createEffect(
    (cd: KirsAssessmentService = inject(KirsAssessmentService)) => {
      return this.actions$.pipe(
        ofType(MassiveEditKirsActions.createAndSignKirsAssessments),
        mergeMap(({ campaignId, legalEntityTrackingId, input, attestationId }) =>
          cd.createAndSignKirsAssessment(campaignId, legalEntityTrackingId, input).pipe(
            mergeMap((giasAssessments) =>
              of(
                MassiveEditKirsActions.createAndSignKirsAssessmentsSuccess({ giasAssessments }),
                MassiveEditKirsActions.loadAllKirsAssessments({
                  attestationId, campaignId, legalEntityIds: null, parameters: {
                    page: 0, rows: 10000000, filters: {}, order: { sortDirection: 'ASC', sortField: null }, search: null
                  }
                })
              )
            ),
            catchError((error) =>
              of(MassiveEditKirsActions.createAndSignKirsAssessmentsFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );

  initialMassiveEdit$ = createEffect(
    (cd: KirsService = inject(KirsService)) => {
      return this.actions$.pipe(
        ofType(MassiveEditKirsActions.initialMassiveEdit),
        mergeMap(({ campaignId, legalEntityTrackingIds, sourceLegalEntity }) =>
          cd.initialMassiveEdit(campaignId, legalEntityTrackingIds, sourceLegalEntity).pipe(
            mergeMap((massiveEdit) =>
              of(
                MassiveEditKirsActions.initialMassiveEditSuccess({ massiveEdit })
              )
            ),
            catchError((error) =>
              of(MassiveEditKirsActions.initialMassiveEditFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );


  constructor(private actions$: Actions) { }
}
